/**
 * @returns x as a string if two strings are the same or throws if they are not
 */
export function assertStringEquality<K extends string, T extends K>(x: K, y: T): K {
    if (x === y) {
        return x;
    }
    throw new Error(`Expected values to be the same received ${x} and ${y}`);
}
